import { Injectable } from '@angular/core';
import { AppInjector } from '../utils/services/set-app-injector';
import SlotService from './slot.service';
import { LoadersService } from '../utils/loaders/loaders.service';
import SlotModel from '../models/slot.model';
import { LoaderActions } from '../utils/loaders/loader-actions.enum';
import {
  NotificationProviderService,
  NotificationProviderTypeEnum
} from '../external-interfaces/notification-provider.service';
import { PagesValidationService } from '../order-fulfillment/pages-validation.service';

@Injectable()
export default class StockValidationService {
  private slotService: SlotService;
  private loadersService: LoadersService;
  private endpoint: any;

  constructor(
    private notificationProvider: NotificationProviderService,
    private pagesValidation: PagesValidationService
  ) {
    this.slotService = AppInjector.get(SlotService);
    this.loadersService = AppInjector.get(LoadersService);
    this.endpoint = AppInjector.get('Endpoint');
  }

  public invalidateStockForBundleNumber(bundleNumber: number): void {
    this.invalidateStockForSlot(this.slotService.findSlotByBundleNumber(bundleNumber));
  }

  public invalidateStockForSlot(slot: SlotModel): void {
    if (slot.hasDevice) {
      this.invalidateStock();
    } else {
      this.pagesValidation.runPageValidationAfterInitPage();
    }
  }

  public invalidateStockForCartWhenDevice(): void {
    if (!this.slotService.hasAtLeastOneDeviceInCart()) {
      return;
    }

    this.invalidateStock();
  }

  public invalidateStock(): void {
    this.loadersService.start(LoaderActions.MODAL_LOADER, {
      message: 'Sprawdzamy dostępność urządzeń'
    }, true);

    this.endpoint('newCart.validateCart')
      .run()
      .then((cartDetailsResponse: any) => {
        const cartDetails = cartDetailsResponse.body.cartDetails;

        this.notificationProvider.publish(
          NotificationProviderTypeEnum.CART_DETAILS,
          cartDetails
        );
      })
      .catch(() => {
        window.location.href = '/cart/multi/error/deviceError';
      })
      .finally(() => {
        this.loadersService.stop(LoaderActions.MODAL_LOADER);
      });
  }
}
